import { createRouteRef } from '@backstage/core-plugin-api';

export const usefulLinksRouteRef = createRouteRef({
         id: 'useful-links',
       });
